import { Component, OnInit, HostListener, Inject, EventEmitter, Output, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { DOCUMENT } from '@angular/common';
import { WINDOW } from "../../services/window.service";
import { filter } from 'rxjs/operators';
import { DataTransferService } from '../../services/DataTransferService';
import { ToastrService } from 'ngx-toastr';
import { LangName } from 'src/app/shared/lang';
import { LanguageService } from 'src/app/services/language/language.service';


@Component({
  selector: 'app-header-private',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderPrivateComponent implements OnInit {
  onTop: boolean;
  Activated: boolean = true;
  currentBranch: any;
  languages = [];
  selectedLanguage = '';
  navStart: Observable<NavigationStart>;
  @Output() lang = new EventEmitter();
  @Output() changeBranch = new EventEmitter();
  dir: string = 'right';
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window,
    private dataTransfer: DataTransferService,
    private toaster: ToastrService,
    private languageService: LanguageService

  ) {

    this.Activated = (this.router.url != '/login' && this.router.url != '/dashboard/outlet-selection');
    this.navStart = router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
    this.onTop = true;

    this.dataTransfer.currentBranch.subscribe((x) => {
      this.currentBranch = x;
      sessionStorage.setItem("branch", JSON.stringify(this.currentBranch));
      var exsistBranch = JSON.parse(sessionStorage.getItem('branch')) as any;
      if (exsistBranch != undefined) {
        this.currentBranch = exsistBranch;
        this.currentBranch = JSON.parse(sessionStorage.getItem('branch'));
      }
    });
  }
  changeLang(lang) {
    this.selectedLanguage = this.languages?.find((item) => item.key == lang)?.value;
    if (lang == "ar") {
      this.dir = "left";
    }
    else if (lang == "en" || lang == "fr") {
      this.dir = "right";
    }
    this.lang.emit({ langObject: lang })
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    if (number > 0) {
      this.onTop = false;
    } else if (number == 0) {
      this.onTop = true;
    }
  }

  requestChange(branch) {
    var company = JSON.parse(sessionStorage.getItem("company"));
    if (company.Branches.length == 1) {
      this.toaster.warning("There is only one branch");
    }
    this.changeBranch.emit({ branch: branch })
  }

  setLanguages(){
    //made an array of languages
    if(Object.keys(LangName).length > 0){
      this.languages = Object.keys(LangName).map(key => ({ key, value: LangName[key] }));
    }
    
    //selected language
    let lang: any = localStorage.getItem('lang');
    if(lang){
      this.selectedLanguage = this.languages?.find((item) => item.key == lang)?.value;
      this.languageService.changeLanguage(lang);
    } else{
      this.selectedLanguage = this.languages?.find((item) => item.key == this.languageService.lang)?.value
    }
  }

  ngOnInit() {
    this.currentBranch = JSON.parse(sessionStorage.getItem("branch"));
    this.dir = (localStorage.getItem('lang') == 'ar' ? 'left' : 'right');
    this.navStart.subscribe(evt => { this.Activated = (evt.url != '/login' && evt.url != '/dashboard/outlet-selection') })
    this.setLanguages();
  }

}
